<app-side-top-bar [navigationItems]="navigationItems">
  <main class="review-invoice-sts">
    <section class="review-invoice-sts-section">
      <header class="header">
        <h2>Riepilogo Spesa STS</h2>
      </header>

      @if (isLoading) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }

      @if (!isLoading && invoiceForm) {
        <div class="review-content">
          <section class="review-block">
            <h3>Dati Documento</h3>
            <dl class="review-grid">
              <div class="review-item">
                <dt>Tipo</dt>
                <dd>{{ formatValue(invoiceForm.get("tipo")?.value) }}</dd>
              </div>
              <div class="review-item">
                <dt>Cliente</dt>
                <dd>{{ formatValue(invoiceForm.get("cliente")?.value) }}</dd>
              </div>
              <div class="review-item">
                <dt>Numero</dt>
                <dd>
                  {{
                    formatValue(invoiceForm.get("progressivo_numero")?.value)
                  }}
                </dd>
              </div>
              <div class="review-item">
                <dt>Data</dt>
                <dd>{{ formatDate(invoiceForm.get("data")?.value) }}</dd>
              </div>
              <div class="review-item">
                <dt>Descrizione</dt>
                <dd>
                  {{ formatValue(invoiceForm.get("riferimento")?.value) }}
                </dd>
              </div>
              <div class="review-item">
                <dt>Opposizione invio CF</dt>
                <dd>
                  {{
                    formatBoolean(invoiceForm.get("flag_opposizione")?.value)
                  }}
                </dd>
              </div>
            </dl>
          </section>

          <section class="review-block">
            <h3>Linee Documento</h3>
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th class="descrizione">descrizione</th>
                    <th class="quantita">quantita</th>
                    <th>importo €</th>
                    <th class="iva">iva</th>
                    <th class="totale">totale</th>
                  </tr>
                </thead>
                <tbody>
                  @for (line of documentLines; track $index) {
                    <tr [class.bollo-line]="line.isBollo">
                      <td>{{ line.descrizione }}</td>
                      <td>{{ line.quantita }}</td>
                      <td>{{ line.prezzo }}</td>
                      <td>{{ line.iva_option }}</td>
                      <td>{{ line.totale }} €</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </section>

          <section class="review-block">
            <h3>Cassa Previdenza</h3>
            <dl class="review-grid">
              <div class="review-item">
                <dt>Tipologia Cassa</dt>
                <dd>{{ tipologiaCassaLabel }}</dd>
              </div>
              <div class="review-item">
                <dt>% Cassa</dt>
                <dd>
                  {{ formatValue(invoiceForm.get("percentuale_cassa")?.value) }}
                </dd>
              </div>
              <div class="review-item">
                <dt>IVA</dt>
                <dd>
                  {{
                    formatValue(
                      invoiceForm.get("cassa_previdenza_codice_iva")?.value
                    )
                  }}
                </dd>
              </div>
            </dl>
          </section>

          <section class="review-block">
            <h3>Dati Pagamento</h3>
            <dl class="review-grid">
              <div class="review-item">
                <dt>Scadenza</dt>
                <dd>{{ formatValue(invoiceForm.get("scadenza")?.value) }}</dd>
              </div>
              <div class="review-item">
                <dt>Pagamento</dt>
                <dd>{{ formatValue(invoiceForm.get("pagamento")?.value) }}</dd>
              </div>
              @if (invoiceForm.get("pagamento")?.value === "Bonifico") {
                <div class="review-item">
                  <dt>Banca</dt>
                  <dd>
                    {{
                      formatValue(invoiceForm.get("doctor_bank_name")?.value)
                    }}
                  </dd>
                </div>
                <div class="review-item">
                  <dt>IBAN</dt>
                  <dd>
                    {{
                      formatValue(invoiceForm.get("doctor_bank_iban")?.value)
                    }}
                  </dd>
                </div>
              }
            </dl>
          </section>

          <section class="totals-section">
            <h3>Riepilogo</h3>
            <div class="total-row">
              <span class="label">{{ imponibileLabel }}</span>
              <span class="value"
                >{{ invoiceForm.get("imponibile")?.value || "0.00" }} €</span
              >
            </div>
            <div class="total-row">
              <span class="label">Cassa Previdenza:</span>
              <span class="value"
                >{{
                  invoiceForm.get("totale_cassa_previdenza")?.value || "0.00"
                }}
                €</span
              >
            </div>
            <div class="total-row">
              <span class="label">Imposta:</span>
              <span class="value"
                >{{ invoiceForm.get("imposta")?.value || "0.00" }} €</span
              >
            </div>
            @if (showBolloRow) {
              <div class="total-row">
                <span class="label">Bollo:</span>
                <span class="value"
                  >{{ invoiceForm.get("bollo")?.value || "0.00" }} €</span
                >
              </div>
            }
            <div class="total-row total">
              <span class="label">Totale:</span>
              <span class="value"
                >{{ invoiceForm.get("totale")?.value || "0.00" }} €</span
              >
            </div>
          </section>

          <div class="form-buttons">
            @if (isReadyView) {
              <button
                class="button-white"
                mat-stroked-button
                type="button"
                [disabled]="isSaving"
                (click)="onClose()"
              >
                Chiudi
              </button>
              <button
                class="button-white"
                mat-stroked-button
                color="primary"
                type="button"
                [disabled]="isSaving"
                (click)="onRetrocedeToBozza()"
              >
                Converti a Bozza
              </button>
            } @else {
              <button
                class="button-white"
                mat-stroked-button
                type="button"
                [disabled]="isSaving"
                (click)="onDelete()"
              >
                Annulla
              </button>
              <button
                class="button-white"
                mat-stroked-button
                type="button"
                [disabled]="isSaving"
                (click)="onBackToEdit()"
              >
                Modifica
              </button>
              <button
                class="button-white"
                mat-stroked-button
                color="primary"
                type="button"
                [disabled]="isSaving"
                (click)="onSaveDraft()"
              >
                Salva Bozza
              </button>
              <button
                class="button-white"
                mat-stroked-button
                color="primary"
                type="button"
                [disabled]="isSaving"
                (click)="onSaveReady()"
              >
                Salva Pronta
              </button>
            }
          </div>
        </div>
      }
    </section>
  </main>
</app-side-top-bar>
